/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Export_ValueInputs */

const en_us2_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file with everything the app keeps`)
};

const pt_br2_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um arquivo com tudo o que o app guarda`)
};

const es_419_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un archivo con todo lo que guarda la app`)
};

const pt_pt2_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ficheiro com tudo o que a app guarda`)
};

const fr_fr2_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fichier avec tout ce que l'app conserve`)
};

const de_de2_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Datei mit allem, was die App speichert`)
};

const it_it2_search_field_export_value = /** @type {(inputs: Search_Field_Export_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un file con tutto ciò che l'app conserva`)
};

/**
* | output |
* | --- |
* | "A file with everything the app keeps" |
*
* @param {Search_Field_Export_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_export_value = /** @type {((inputs?: Search_Field_Export_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Export_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_export_value(inputs)
	if (locale === "es-419") return es_419_search_field_export_value(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_export_value(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_export_value(inputs)
	if (locale === "de-DE") return de_de2_search_field_export_value(inputs)
	if (locale === "it-IT") return it_it2_search_field_export_value(inputs)
	return en_us2_search_field_export_value(inputs)
});
export { search_field_export_value as "search.field_export_value" }